<template>
  <div class="task-feedback-wrapper" ref="wrapperRef">
    <div  class="task-feedback" v-if="list && list.length > 0" @scroll="onScroll">
      <div ref="contentRef">
        <div class="task-feedback-item" v-for="(item, index) in list" :key="index" @click="openDetail1(item)">
          <div class="task-feedback-left">
            <div class="task-feedback-icon"></div>
            <div class="task-feedback-info">
              <div class="task-feedback-title">{{item.msg || item.name}}</div>
              <div class="task-feedback-desc">{{item.type_name}}</div>
            </div>
          </div>
          <div class="task-feedback-right">
            <div v-show="item.type == 5 && item.process != 100" class="task-feedback-process">{{item.process + '%' || '0%'}}</div>
            <img v-if="item.status == '2'" src="@/assets/img/headline/select.svg" alt="" style="width: 14px"/>
            <div v-else :class="['task-feedback-status', item.status == '3' ? 'is-error':'']">{{item.status_name}}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="task-feedback-empty">
      <img src="../../assets/img/common/newEmpty.png" alt="">
      <p>暂无消息</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TaskFeedback',
  props: {
    list: {
      type: Array,
      default: ()=>{
        return []
      }
    }
  },
  methods: {
    openDetail1(item){
      this.$emit('open', item)
    },
    onScroll(e){
      const height = this.$refs.wrapperRef.clientHeight
      const offsetHeight = this.$refs.contentRef.offsetHeight
      const scrollTop = e.target.scrollTop
      if (scrollTop / (offsetHeight - height + 0.2) >= 0.95) {
        this.$emit('load')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.task-feedback {
  height: 100%;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(#dcdcdc, 0.3);
    border-radius: 4px;
  }

  &-wrapper {
    height: 100%;
    overflow: hidden;
  }

  &-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 64px;
    box-sizing: border-box;
    padding-left: 30px;
    padding-right: 40px;
    &.is-active,
    &:hover {
      background: #F5F6F6;
      .task-feedback-title {
        color: #41B48B;
      }
    }
  }

  &-left {
    flex: 1;
    display: flex;
    align-items: center;
    overflow: hidden;
    box-sizing: border-box;
  }

  &-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &-icon {
    width: 40px;
    height: 40px;
    border-radius: 6px 6px 6px 6px;
    background: rgba(65,180, 140, 0.06);
    background-image: url("../../assets/img/headline/task.svg");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 20px 20px;
  }

  &-info {
    flex: 1;
    overflow: hidden;
    padding: 0 12px;
  }

  &-title {
    font-weight: 500;
    font-size: 14px;
    color: #050F0F;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 23px;
    overflow: hidden;
  }

  &-desc {
    font-weight: 400;
    font-size: 12px;
    color: #829191;
    line-height: 20px;
  }

  &-status {
    font-weight: 400;
    font-size: 12px;
    color: #41B48C;
    line-height: 20px;
    &.is-error {
      color: #FF565A;
    }

  }
  &-process {
    font-weight: 400;
    font-size: 12px;
    color: #41B48C;
    line-height: 20px;
    padding-right: 10px;
  }

  &-empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    p {
      font-size: 14px;
      line-height: 20px;
      color: #B9C3C3;
      font-weight: 500;
      margin-top: 14px;
    }
  }
}
</style>
